import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/store/index.js"
import storage from "./storage.js"
import router from "@/router/index.js"

const instance = axios.create({

    baseURL: load.getUrlApi(),
});

// ----------------------------------
// ------------ REQUEST -------------
// ----------------------------------
instance.interceptors.request.use(config => {

    // Attesa
    /* store.commit('app/setLoading', true)*/

    // Imposto il token
    if (store.getters['auth/isAuthenticated'])
        config.headers.Authorization = storage.getAuthHeader()

    return config

}, function (error) {

    // Fine attesa
    /*   store.commit('app/setLoading', false) */

    // Request error
    console.log("request interceptor " + error)

    return Promise.reject(error)
})


// ----------------------------------
// ------------ RESPONSE ------------
// ----------------------------------
instance.interceptors.response.use(response => {

    // Fine attesa
    /*   store.commit('app/setLoading', false) */

    return response

}, function (error) {

    let originalRequest = error.config


    // Controllo scadenza token
    if (error.response && error.response.status === 401 && !originalRequest._retry) {

        originalRequest._retry = true

        // Login con refreshToken
        console.log("refreshtoken");
        return store.dispatch("auth/refreshToken").then(authResponse => {

            instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
            originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token

            return instance(originalRequest)

        })
            .catch(err => {
                console.log(err)

                if (storage.isImpersonating()) {
                    // Sessione di impersonificazione scaduta: torna alla sessione
                    // SuperAdmin invece di sloggare del tutto.
                    storage.endImpersonation()
                } else {
                    // Pulisce il token usando la mutation appena creata
                    store.commit("auth/DEL_TOKEN")

                    // Reindirizza l'utente alla pagina di login
                    router.push({ name: 'login' })
                }
            });
    }

    // Fine attesa
    /*   store.commit('app/setLoading', false) */

    console.log("response interceptor " + error)

    // Messaggio errore: mostra sempre quello restituito dal backend (pattern
    // `{ message: "..." }` usato da tutti i controller, es. eliminazioni bloccate
    // da vincoli) in uno snackbar globale — prima l'errore restava solo in
    // console e l'utente non capiva perché l'azione non avesse effetto. Il 401
    // è escluso: quel caso è già gestito sopra (refresh token / redirect login).
    if (!error.response || error.response.status !== 401) {
        const messaggio = (error.response && error.response.data && error.response.data.message)
            || "Si è verificato un errore. Riprova."
        store.commit("app/SHOW_MESSAGE", { text: messaggio, color: "error" })
    }

    return Promise.reject(error);

})

export default instance